/**
 * Prompt version/hash comparison section.
 *
 * @module config-comparison/PromptDiffSection
 */
import React from 'react';
import { Text } from '@chatsdet/ui';
import type { EnvironmentSnapshot } from '@chatsdet/types';
import { DiffTable } from './DiffTable';
import { diffRecordMap } from './diff-utils';

interface PromptDiffSectionProps {
  promptsA: EnvironmentSnapshot['prompts'] | undefined;
  promptsB: EnvironmentSnapshot['prompts'] | undefined;
  labelA: string;
  labelB: string;
}

export function PromptDiffSection({ promptsA, promptsB, labelA, labelB }: PromptDiffSectionProps) {
  const rows = React.useMemo(
    () => diffRecordMap(promptsA, promptsB, {
      format: (p) => `v${p.version} (${p.contentHash.slice(0, 8)})`,
      isEqual: (a, b) => a.version === b.version && a.contentHash === b.contentHash,
    }),
    [promptsA, promptsB],
  );

  return (
    <div>
      <Text weight="medium" className="mb-2">Prompts</Text>
      <DiffTable rows={rows} labelA={labelA} labelB={labelB} />
    </div>
  );
}
